import { cn } from "../../../lib/utils";
import { CalendarDayNumber } from "./calendar-day-number";
import { CalendarEventItem } from "./calendar-event-item";
import type { CalendarEvent } from "./types";

export type CalendarCellProps = {
    className?: string;
    /** ISO date (YYYY-MM-DD) of the cell. */
    date: string;
    day: number;
    events: CalendarEvent[];
    /** Whether the cell belongs to an adjacent month. */
    muted?: boolean;
};

export function CalendarCell({ className, date, day, events, muted = false }: CalendarCellProps) {
    return (
        <div
            className={cn("flex h-36 flex-col gap-1 p-1.5", muted && "bg-muted/40", className)}
        >
            <CalendarDayNumber date={date} day={day} muted={muted} />
            {events.length > 0 ? (
                <div className="min-h-0 flex-1 overflow-y-auto [mask-image:linear-gradient(to_bottom,black_calc(100%-0.75rem),transparent)] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                    <ul className="flex flex-col gap-1 pb-3">
                        {events.map((event) => (
                            <li key={`${event.id}-${event.date}`}>
                                <CalendarEventItem event={event} />
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </div>
    );
}
